<template>
  <div style="">
    <div class="mainTitle">
      <div>
        <span class="userName">{{ ais_info.name_cn }}</span>
        <span style="margin-left: 20px">{{ ais_info.label }}</span>
        <div class="rightBtn">
          <!-- <el-button-group> -->
          <el-button plain size="small" @click="modifyLabel()"
            >修改标签</el-button
          >
          <el-button plain size="small" @click="modifyRemarks()"
            >修改备注</el-button
          >
          <!-- </el-button-group> -->
          <el-button type="primary" size="small" @click="verifyEdit()"
            >编辑</el-button
          >
        </div>
      </div>
      <div class="infos">
        <div class="info1">
          <p>
            <span>英文姓名:&nbsp;</span>
            {{ ais_info.name_en }}
          </p>
          <p>
            <span>学号:&nbsp;</span>
            {{ ais_info.student_no }}
          </p>
          <p>
            <span>UID:&nbsp;</span>
            {{ ais_info.uid }}
          </p>
        </div>
        <div class="info1">
          <p>
            <span>深造状态:&nbsp;</span>
            {{ ais_info.education_status }}
          </p>
          <p>
            <span>工作状态:&nbsp;</span>
            {{ ais_info.status }}
          </p>
          <p>
            <span>入学年份:&nbsp;</span>
            {{ ais_info.year }}
          </p>
        </div>
        <div class="info1">
          <p>
            <span>校友福利:&nbsp;</span>
            {{ ais_info.welfare_gymnasium_setting }}
          </p>
          <p>
            <span>校友状态:&nbsp;</span>
            {{ ais_info.alumni_status }}
          </p>
          <p>
            <span>备注:&nbsp;</span>
            {{ ais_info.remark }}
          </p>
        </div>
        <div class="info2">
          <div class="divStyle">
            <p>捐助金额</p>
            <h1>{{ journalSum }}</h1>
          </div>
          <div class="divStyle">
            <p>校友邮箱状态</p>
            <h1>{{ ais_info.is_email == 1 ? "已开通" : "未开通" }}</h1>
          </div>
          <div class="divStyle">
            <p>校友帐号状态</p>
            <h1>{{ ais_info.is_account == 1 ? "已开通" : "未开通" }}</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="maintitle">
      <h4 class="firstTitle">校友信息</h4>
      <hr />
    </div>
    <div class="mainbody">
      <div class="baseInfo">
        <div class="info">
          <p>
            <span>出生日期:&nbsp;</span>
            {{ ais_info.date_of_birth }}
          </p>
          <p>
            <span>国家地区:&nbsp;</span>
            {{ ais_info.region }}
          </p>
          <p>
            <span>籍贯-省份:&nbsp;</span>
            {{ ais_info.navtive_province }}
          </p>
          <p>
            <span>籍贯-城市:&nbsp;</span>
            {{ ais_info.navtive_city }}
          </p>
          <p>
            <span>会员类别:&nbsp;</span>
            {{ ais_info.member_type }}
          </p>
          <h4>教育信息</h4>

          <p>
            <span>专业:&nbsp;</span>
            {{ ais_info.programme }}
          </p>
          <p>
            <span>招生类型:&nbsp;</span>
            {{ ais_info.admission_category }}
          </p>
          <p>
            <span>入学时间:&nbsp;</span>
            {{ ais_info.year }}
          </p>
        </div>
        <div class="info">
          <p>
            <span>性别:&nbsp;</span>
            {{ gender[ais_info.gender] }}
          </p>
          <p>
            <span>身份证号:&nbsp;</span>
            {{ ais_info.id_card_number }}
          </p>
          <p>
            <span>生源地:&nbsp;</span>
            {{ ais_info.origin_place }}
          </p>
          <p>
            <span>生源高中:&nbsp;</span>
            {{ ais_info.origin_high_school }}
          </p>
          <p>
            <span>校友类别:&nbsp;</span>
            {{ ais_info.alumni_type }}
          </p>
          <!-- <h4 class="h4place">占位</h4> -->
          <h4 class="h4place">占位</h4>

          <p>
            <span>学部:&nbsp;</span>
            {{ ais_info.division }}
          </p>
          <p>
            <span>荣誉分类:&nbsp;</span>
            {{ ais_info.honours_classification }}
          </p>
          <p>
            <span>毕业时间:&nbsp;</span>
            {{ ais_info.graduation_year }}
          </p>
        </div>
        <div class="info">
          <el-image class="photo" :src="aisPhotoUrl" fit="cover"></el-image>
        </div>
      </div>
      <div class="baseInfo">
        <div class="info">
          <h4>联系信息</h4>
          <p>
            <span>联系电话:&nbsp;</span>
            {{ ais_info.mobile_phone }}
          </p>
          <p>
            <span>微信:&nbsp;</span>
            {{ ais_info.wechat }}
          </p>
          <h4>家庭信息</h4>
          <p>
            <span>所在省份:&nbsp;</span>
            {{ ais_info.family_province }}
          </p>
          <p>
            <span>父亲名称:&nbsp;</span>
            {{ ais_info.father_name }}
          </p>
          <p>
            <span>父亲单位:&nbsp;</span>
            {{ ais_info.father_employment }}
          </p>
          <p>
            <span>母亲名称:&nbsp;</span>
            {{ ais_info.mother_name }}
          </p>
          <p>
            <span>母亲单位:&nbsp;</span>
            {{ ais_info.mother_employment }}
          </p>
        </div>
        <div class="info">
          <h4 class="h4place">占位</h4>
          <p>
            <span>校友邮箱:&nbsp;</span>
            {{ ais_info.alumni_email }}
          </p>
          <p>
            <span>该数据更新时间:&nbsp;</span>
            {{ ais_info.contact_record_time }}
          </p>
          <h4 class="h4place">占位</h4>
          <p>
            <span>城市:&nbsp;</span>
            {{ ais_info.family_city }}
          </p>
          <p>
            <span>父亲联系方式:&nbsp;</span>
            {{ ais_info.father_contact_number }}
          </p>
          <p class="pplace">占位</p>
          <p>
            <span>母亲联系方式:&nbsp;</span>
            {{ ais_info.mother_contact_number }}
          </p>
          <p>
            <span>该数据更新时间:&nbsp;</span>
            {{ ais_info.family_record_time }}
          </p>
        </div>
        <div class="info">
          <h4 class="h4place">占位</h4>
          <p>
            <span>常用邮箱:&nbsp;</span>
            {{ ais_info.active_email }}
          </p>
          <p class="pplace">占位</p>
          <h4 class="h4place">占位</h4>
          <p>
            <span>家庭地址:&nbsp;</span>
            {{ ais_info.family_address }}
          </p>
          <p>
            <span>父亲职位:&nbsp;</span>
            {{ ais_info.father_position }}
          </p>
          <p class="pplace">占位</p>
          <p>
            <span>母亲职位:&nbsp;</span>
            {{ ais_info.mother_position }}
          </p>
          <p class="pplace">占位</p>
        </div>
      </div>

      <div style="clear: both"></div>
      <div class="tableInfo">
        <h3 class="title">深造信息</h3>
        <div class="aLine"></div>
        <el-table :data="ais_education">
          <el-table-column
            prop="education_status"
            label="状态"
            min-width="1"
          ></el-table-column>
          <el-table-column label="所在地" min-width="2">
            <template slot-scope="scope">
              {{ getEduLocation(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="education_school"
            label="院校名称"
            min-width="2"
          ></el-table-column>
          <el-table-column
            prop="education_programme"
            label="院校专业"
            min-width="2"
          ></el-table-column>
          <el-table-column
            prop="education_graduation_year"
            label="毕业年份"
            min-width="1"
          ></el-table-column>
          <el-table-column
            prop="education_other"
            label="其他"
            min-width="2"
          ></el-table-column>
          <el-table-column
            prop="record_time"
            label="更新时间"
            min-width="2"
          ></el-table-column>
        </el-table>
      </div>
      <div class="tableInfo">
        <h3 class="title">工作信息</h3>
        <div class="aLine"></div>
        <el-table :data="ais_job_info">
          <el-table-column
            prop="status"
            label="状态"
            min-width="1"
          ></el-table-column>
          <el-table-column label="所在地" min-width="2">
            <template slot-scope="scope">
              {{ getJobLocation(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="organization"
            label="单位名称"
            min-width="1"
          ></el-table-column>
          <el-table-column
            prop="unit_property"
            label="单位性质"
            min-width="1"
          ></el-table-column>
          <el-table-column
            prop="job_type"
            label="行业类型"
            min-width="1"
          ></el-table-column>
          <el-table-column
            prop="position"
            label="工作职位"
            min-width="1"
          ></el-table-column>
          <el-table-column
            prop="pay"
            label="薪酬范围"
            min-width="1"
          ></el-table-column>
          <el-table-column
            prop="registered_address"
            label="公司注册地"
            min-width="1"
          ></el-table-column>
          <el-table-column
            prop="employees"
            label="雇员人数"
            min-width="1"
          ></el-table-column>
          <el-table-column
            prop="turnover"
            label="年营业额"
            min-width="1"
          ></el-table-column>
          <el-table-column
            prop="freelance"
            label="从事何种自由职业"
            min-width="2"
          ></el-table-column>
          <el-table-column
            prop="record_time"
            label="更新时间"
            min-width="2"
          ></el-table-column>
        </el-table>
      </div>
      <div class="tableInfo">
        <h3 class="title">捐助信息</h3>
        <div class="aLine"></div>
        <el-table :data="ais_journal">
          <el-table-column
            prop="idshow"
            label="ID"
            min-width="1"
          ></el-table-column>
          <el-table-column
            prop="journal_time"
            label="捐助时间"
            min-width="2"
          ></el-table-column>
          <el-table-column
            prop="content"
            label="捐助内容"
            min-width="2"
          ></el-table-column>
          <el-table-column
            prop="money"
            label="捐助金额"
            min-width="2"
          ></el-table-column>
          <el-table-column
            prop="type"
            label="捐助类型"
            min-width="2"
          ></el-table-column>
          <el-table-column
            prop="bill_status"
            label="票据"
            min-width="2"
          ></el-table-column>
          <el-table-column
            prop="certificate_status"
            label="证书"
            min-width="2"
          ></el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
            min-width="2"
          ></el-table-column>
          <el-table-column
            prop="record_time"
            label="更新时间"
            min-width="2"
          ></el-table-column>
          <el-table-column prop="operating" label="" min-width="1" align="left">
            <template slot-scope="scope">
              <el-button
                class="operateText"
                size="mini"
                type="text"
                @click="journalDetails(scope.row)"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="tableInfo">
        <h3 class="title">
          荣誉信息（在校期间所获奖学金及其他荣誉信息；毕业后所获荣誉信息）
        </h3>
        <div class="aLine"></div>
        <el-table :data="ais_honor">
          <el-table-column
            prop="idshow"
            label="ID"
            min-width="1"
          ></el-table-column>
          <el-table-column
            prop="honor_time"
            label="荣誉时间"
            min-width="2"
          ></el-table-column>
          <el-table-column
            prop="content"
            label="荣誉内容"
            min-width="2"
          ></el-table-column>
          <el-table-column
            prop="record_time"
            label="更新时间"
            min-width="2"
          ></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import * as CApi from "@/api/constant_api.js";
import * as Api from "@/api/api.js";
import * as StrUtils from "@/utils/strUtils.js";
import { formar_gender } from "@/utils/constant.js";
import { getJobLocation, getEduLocation } from "@/utils/strUtils.js";
import { URL_PATH } from "@/config/config";
import modifyRemarksDialog from "@/components/dialog/modifyRemarksDialog";

export default {
  components: {
    modifyRemarksDialog,
  },
  props: ["ais_info"],
  data() {
    return {
      URL_PATH: URL_PATH,
      journalSum: "¥ 0", //捐助金额
      aisPhotoUrl: "",
      ais_education: [], //深造信息
      ais_job_info: [], // 工作列表
      ais_journal: [], //捐助信息
      ais_honor: [], //荣誉信息
      gender: formar_gender,
    };
  },
  mounted() {
    this.getAisJournalMoneyTotal();
    this.getAisPhoto();
    this.getAisJobInfoById();
    this.getAisEducationById();
    this.getAisJournalById();
    this.getAisHonorById();
  },
  methods: {
    // 修改标签
    modifyLabel() {
      Api.verifyApi(CApi.api_updateAisLabel, (verify) => {
        if (verify) {
          var label = this.ais_info.label;
          this.$prompt("修改校友标签", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            inputValue: label,
          })
            .then(({ value }) => {
              this.ais_info.label = value;
              this.$api
                .updateAisLabel({
                  token: localStorage.getItem("token"),
                  id: this.ais_info.id,
                  label: value,
                })
                .then(({ data }) => {});
            })
            .catch(() => {});
        }
      });
    },
    // 修改备注
    modifyRemarks() {
      Api.verifyApi(CApi.api_updateAisRemark, (verify) => {
        if (verify) {
          var remark = this.ais_info.remark;
          this.$prompt("修改校友备注信息", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            inputPattern: /^(a-z|A-Z|0-9)*[^$%^&*;:,<>?()\""\']{0,25}$/,
            inputErrorMessage: "备注限制25个字符",
            inputValue: remark,
          })
            .then(({ value }) => {
              this.ais_info.remark = value;
              this.$api
                .updateAisRemark({
                  token: localStorage.getItem("token"),
                  id: this.ais_info.id,
                  remark: value,
                })
                .then(({ data }) => {});
            })
            .catch(() => {});
        }
      });
    },
    // 验证是否能编辑
    verifyEdit() {
      Api.verifyApi(CApi.api_updateAisById, (verify) => {
        if (verify) {
          this.userEdit();
        }
      });
    },
    $toSaveEditRemarks(remark) {
      this.ais_info.remark = remark;
      this.$api
        .updateAisRemark({
          token: localStorage.getItem("token"),
          id: this.ais_info.id,
          remark: remark,
        })
        .then(({ data }) => {});
    },
    // 编辑
    userEdit() {
      this.$router.push({
        path: "/data/user-edit",
        query: { id: this.ais_info.id },
      });
    },
    // 获取捐助金额
    getAisJournalMoneyTotal: function () {
      this.$api
        .getAisJournalMoneyTotal({
          token: localStorage.getItem("token"),
          id: this.ais_info.id,
        })
        .then(({ data }) => {
          this.journalSum = "¥ " + data.Data.money_total.toFixed(2);
        })
        .catch(({ error }) => {});
    },
    // 获取校友头像
    getAisPhoto: function () {
      this.$api
        .getAishoto({
          token: localStorage.getItem("token"),
          id: this.ais_info.id,
        })
        .then(({ data }) => {
          // console.log(data);
          this.aisPhotoUrl = this.URL_PATH + data.Data.photo;
        })
        .catch(({ error }) => {});
    },
    // 获取工作信息
    getAisJobInfoById: function () {
      this.$api
        .getAisJobInfoById({
          token: localStorage.getItem("token"),
          id: this.ais_info.id,
        })
        .then(({ data }) => {
          // 获取校友工作信息列表
          this.ais_job_info = data.Data;
        })
        .catch(({ error }) => {});
    },
    // 获取深造信息
    getAisEducationById: function () {
      this.$api
        .getAisEducationById({
          token: localStorage.getItem("token"),
          id: this.ais_info.id,
        })
        .then(({ data }) => {
          // debugger
          this.ais_education = data.Data;
        })
        .catch(({ error }) => {});
    },
    // 获取捐助信息
    getAisJournalById: function () {
      this.$api
        // .getAisJournalById({
        .getJournalById({
          token: localStorage.getItem("token"),
          id: this.ais_info.id,
        })
        .then(({ data }) => {
          this.ais_journal = data.Data;
          this.ais_journal.forEach((element) => {
            element.idshow = element.id.substring(
              element.id.length - 6,
              element.id.length
            );
            element.bill_status = StrUtils.getBillStatus(element.bill_status);
            element.certificate_status = StrUtils.getCertificateStatus(
              element.certificate_status
            );
          });
        })
        .catch(({ error }) => {});
    },
    // 获取荣誉信息
    getAisHonorById: function () {
      this.$api
        .getAisHonorById({
          token: localStorage.getItem("token"),
          id: this.ais_info.id,
        })
        .then(({ data }) => {
          this.ais_honor = data.Data;
          this.ais_honor.forEach((element) => {
            element.idshow = element.id.substring(
              element.id.length - 6,
              element.id.length
            );
          });
        })
        .catch(({ error }) => {});
    },
    // 查看捐献详情
    journalDetails(row) {
      let manual = "donationApplets" == row.type_en;
      Api.verifyApi(
        manual ? CApi.api_getAppletsDonationInfo : CApi.api_getDonationInfo,
        (verify) => {
          if (verify) {
            let path = manual
              ? "/data/journal-details"
              : "/data/journal-details-manual";
            this.$router.push({
              path: path,
              query: {
                id: row.id,
              },
            });
          }
        }
      );
    },
    getJobLocation(val) {
      return getJobLocation(val);
    },
    getEduLocation(val) {
      return getEduLocation(val);
    },
  },
};
</script>

<style lang="less" scoped>
.mainTitle {
  //   background-color: #ffffff;
  //   border-radius: 5px;
  overflow: hidden;
  // padding-bottom: 50px;
  padding: 34px 32px 0 32px;
  // margin:0 32px;
  margin-top: 24px;
  // margin-left: -20px;
  // margin-right: -20px;
}
.mainTitle .userName {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.85);
}
.mainTitle .rightBtn {
  float: right;
}
.mainTitle .infos {
  width: 100%;
  float: left;
}
.mainTitle .infos span {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.85);
}
.mainTitle .infos p {
  font-family: Helvetica Neue;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.65);
}
.mainTitle .infos h1 {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.85);
}
.mainTitle .info1 {
  width: 23%;
  float: left;
}
.mainTitle .info2 {
  width: 30%;
  float: right;
}
.mainTitle .info2 .divStyle {
  width: 30%;
  float: right;
}
.mainTitle .info2 .divStyle p {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.45);
  // float: right;
}
.mainTitle .info2 .divStyle h1 {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.85);
  // float: right;
}
.maintitle {
  background: #ffffff;
  overflow: hidden;
}
.maintitle .firstTitle {
  font-family: PingFang SC;
  font-style: normal;
  //   font-weight: 900 ;
  font-size: 15px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  margin-left: 32px;
  margin-top: 32px;
  margin-bottom: 20px;
}
.mainbody {
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  padding: 15px 32px 32px 32px;
}
.title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);

  //   background-color: #ffffff;
}
hr {
  height: 1px;
  border-top: 1px solid #e4e7ed;
  border-right: 0px;
  border-bottom: 0px;
  border-left: 0px;
  // border: 0;
}
.mainbody .baseInfo {
  width: 100%;
  float: left;
}
.mainbody .info {
  width: 33%;
  float: left;
}
.mainbody .photo {
  float: left;
  width: 222px;
  height: 220px;
  margin-top: 18px;
  background-color: #c4c4c4;
  border-radius: 0px;
}
.mainbody .info h4 {
  margin-top: 24px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.85);
}
.mainbody .info .h4place {
  margin-top: 24px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 22px;
  color: #00000000;
}

.mainbody .info span {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.85);
}
.mainbody .info p {
  margin-top: 16px;
  font-family: Helvetica Neue;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.65);
}
.mainbody .info .pplace {
  margin-top: 16px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #00000000;
}
.mainbody .tableInfo {
  margin-top: 24px;
  border: 1px solid #e9e9e9;
  box-sizing: border-box;
}
.mainbody .tableInfo .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  padding: 11px 24px;
  background: #fafafa;
  // border: 1px solid #e9e9e9;
  box-sizing: border-box;
}
.mainbody .tableInfo .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
</style>



// WEBPACK FOOTER //
// src/pages/dataMgr/detailList.vue